<template>
  <span style="white-space: nowrap;">
    {{coinsToString(amount)}}<v-icon style="color:inherit;font-size:inherit;margin-left:0.2em;padding-bottom:0.1em;">mdi-circle-multiple-outline</v-icon>
  </span>
</template>

<script>

import coinMixin from "@/mixins/coinMixin";

export default {
  name: "CoinsWidget",
  mixins: [coinMixin],
  components: {},
  props: {
    amount: {
      type: Number,
      required: true
    },
  },
};
</script>